export enum DialogDataType {
  Delete = 'delete-confirmation',
  Info = 'info-dialog'
}